import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import {environment} from '../../environments/environment';
import { SecureStorageService } from '../secure-storage/secure-storage.service';

@Injectable({
	providedIn: 'root'
})

export class ParameterService {

	constructor(
		private http: HttpClient,
		private secureStorage: SecureStorageService,
	) { }

	getRoleUser() {
		return this.http.get<any>(environment.financialUrl + '/parameter/' + this.secureStorage.getItem('country') + '/' + this.secureStorage.getItem('username'));
	}

	getApsRole() {
		return this.http.post<any>(environment.financialUrl + '/aps', {
			userId: this.secureStorage.getItem('username'),
		});
	}

}
